// extracted by mini-css-extract-plugin
export var featuresContent = "DevToolFeaturesList-module--featuresContent--XyGtv";
export var lightFeaturesContent = "DevToolFeaturesList-module--lightFeaturesContent--DnrAe";
export var features = "DevToolFeaturesList-module--features--2M0Qq";